import { useAtomValue } from 'jotai';

import { meOrgState } from '../atom';

export const useMeOrg = () => {
  const org = useAtomValue(meOrgState);

  return { org };
};
